import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SubtitleTimelineCue from './SubtitleTimelineCue';
import SubtitleTimelineReferenceLine from './SubtitleTimelineReferenceLine';
import SubtitleTimelineTimeSections from './SubtitleTimelineTimeSections';

import SubtitleActions from '../SubtitleActions';
import SubtitleService from '../SubtitleService';

@inject((stores) => ({
  cues: stores.SubtitleStore.cues,
  duration: stores.SubtitleStore.duration,
  scrollPosition: stores.SubtitleStore.scrollPosition,
  zoom: stores.SubtitleStore.zoom,
  currentCue: stores.SubtitleStore.currentCue
}))
@observer
class SubtitleTimelineArea extends Component {
  timelineTimeSections = React.createRef();

  get timeSectionsWidth() {
    return this.timelineTimeSections.current.offsetWidth;
  }

  get timeCuesWidth() {
    return this.props.forwardRef.current.offsetWidth;
  }

  static propTypes = {
    cues: PropTypes.object,
    duration: PropTypes.number,
    width: PropTypes.number,
    scrollPosition: PropTypes.number,
    forwardRef: PropTypes.func,
    currentCue: PropTypes.object,
    zoom: PropTypes.number
  };

  render() {
    const { width, duration, cues, scrollPosition, forwardRef } = this.props;

    if (forwardRef && forwardRef.current) {
      forwardRef.current.scrollLeft =
        forwardRef.current.scrollWidth * scrollPosition;
    }

    return (
      <div className="subtitle__timeline__area" onWheel={this.onWheel}>
        <div ref={forwardRef} className="subtitle__timeline__time__cues">
          <div className="subtitle__timeline__cues">
            {cues.map(this.renderCue)}
          </div>

          <SubtitleTimelineTimeSections
            onMove={this.moveScroll}
            ref={this.timelineTimeSections}
            width={width}
            duration={duration}
          />
        </div>

        <SubtitleTimelineReferenceLine timelineWidth={width} />
      </div>
    );
  }

  renderCue = (cue, index) => {
    const { currentCue, zoom } = this.props;

    return (
      <SubtitleTimelineCue
        key={`timeline__${cue.id}`}
        index={index}
        onResizeCue={this.resizeCue}
        onMoveCue={SubtitleActions.moveCue}
        onClose={SubtitleActions.removeCue}
        onAdd={this.addNewCueEnd}
        zoom={zoom}
        currentCue={currentCue}
        {...cue}
      />
    );
  };

  addNewCueEnd = (currentCue) => {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const startTime = currentCue.endTime + 0.01;

    SubtitleActions.addCue(startTime);
  };

  onWheel = (event) => {
    event.preventDefault();
    this.moveScroll(event.deltaY);
  };

  moveScroll = (pixelsMoved) => {
    pixelsMoved *= -1;

    SubtitleActions.movePixels(pixelsMoved, this.timeCuesWidth);
  };

  resizeCue = (position, cue, type) => {
    const newTime = this.getCursorTimePosition(position);

    SubtitleActions.resizeCue(newTime, cue, type);
  };

  getCursorTimePosition(mouseX) {
    const { forwardRef } = this.props;

    const rect = forwardRef.current.getBoundingClientRect();

    const mousePositionVisible = mouseX - rect.left;
    const mousePosition = mousePositionVisible + forwardRef.current.scrollLeft;

    return SubtitleService.convertBasePixelsToSeconds(mousePosition);
  }
}

const WrappedSubtitleTimelineArea = (props, ref) => {
  return <SubtitleTimelineArea forwardRef={ref} {...props} />;
};

export default React.forwardRef(WrappedSubtitleTimelineArea);
